import { ScreenOrientation } from '@capacitor/screen-orientation';
import img from 'app/img';
import dashjs from 'dashjs';
import DPlayer from 'dplayer';
import { default as Hls } from 'hls.js';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { VideoPlayUrlList } from 'services/apis/cnt2/post-api';
import { getPlatform, isNative } from 'utils/updateManagerRemote';

export type PlayerDT = {
  logo: string;
  pic: string;
  videoPlayUrlList: VideoPlayUrlList;
};
const Player = (data: { playerData?: PlayerDT }) => {
  const defaultState = {
    logo: '/images/logo/uutt.png',
    pic: 'http://localhost/video/2/bg.jpg',
    videoPlayUrlList: [
      {
        no: 1,
        name: 'normal',
        url: 'http://localhost/video/2/mp4/video.mp4',
        type: 'normal',
      },
      {
        no: 2,
        name: 'dash',
        url: 'http://localhost/video/2/dash5/master.mpd',
        // type: 'dash', // https://github.com/Dash-Industry-Forum/dash.js?tab=readme-ov-file#cdn-hosted-files
        type: 'customDash',
      },
      {
        no: 3,
        name: 'hls',
        url: 'http://localhost/video/2/hls/playlist.m3u8',
        // type: 'hls', // https://github.com/video-dev/hls.js?tab=readme-ov-file#using-hlsjs
        type: 'customHls',
      },
    ],
  };
  // const [playerState, setPlayerState] = useState<PlayerDT>(data.playerData);
  const [playerState, setPlayerState] = useState<PlayerDT>(data.playerData == null ? defaultState : data.playerData);

  useEffect(() => {
    console.log('playerState', playerState);
    // 通过创建节点的方式添加 script标签
    // 或 使用 react-helmet
    // 或 使用 npm安装好
    // new Array("https://cdn.jsdelivr.net/npm/hls.js@1",
    //     "https://cdn.dashjs.org/latest/dash.all.min.js",
    //     "https://cdn.jsdelivr.net/npm/dplayer@1.27.1/dist/DPlayer.min.js"
    // ).forEach(scriptUrl => {
    //     const scriptTag = document.createElement('script');
    //     scriptTag.src = scriptUrl;
    //     scriptTag.async = true;
    //     document.body.appendChild(scriptTag);
    // })

    //@ts-ignore
    const dp = new DPlayer({
      container: document.getElementById('dplayer'),
      live: false,
      autoplay: true,
      theme: '#FADFA3',
      loop: true,
      lang: 'zh-cn',
      screenshot: true,
      hotkey: true,
      airplay: false,
      chromecast: false,
      preload: 'metadata', // auto, none, metadata
      volume: 0.7,
      playbackSpeed: [0.5, 0.75, 1, 1.25, 1.5, 2],
      logo: playerState.logo,
      apiBackend: null,
      preventClickToggle: true,
      mutex: true,
      video: {
        defaultQuality: 0,
        quality: playerState.videoPlayUrlList,
        type: 'auto',

        //// dash 播放源
        // url: 'http://localhost/video/2/dash5/master.mpd',
        // type: 'customDash',

        // hls 播放源
        // url: 'http://localhost/video/2/hls/playlist.m3u8',
        // type: 'customHls',

        customType: {
          customDash: function (video, player) {
            dashjs.MediaPlayer().create().initialize(video, video.src, false);
          },
          customHls: function (video, player) {
            const hls = new Hls();
            hls.loadSource(video.src);
            hls.attachMedia(video);
          },
        },

        pic: playerState.pic,
        // thumbnails: 'http://localhost/video/2/bg.jpg',
      },
      pluginOptions: {
        hls: {
          // hls config
        },
        dash: {
          // dash config
        },
      },
      // subtitle: {
      //     url: 'dplayer.vtt',
      //     type: 'webvtt',
      //     fontSize: '25px',
      //     bottom: '10%',
      //     color: '#b7daff',
      // },
      // danmaku: {
      //     id: '9E2E3368B56CDBB4',
      //     api: 'https://api.prprpr.me/dplayer/',
      //     token: 'tokendemo',
      //     maximum: 1000,
      //     addition: ['https://api.prprpr.me/dplayer/v3/bilibili?aid=4157142'],
      //     user: 'DIYgod',
      //     bottom: '15%',
      //     unlimited: true,
      //     speedRate: 0.5,
      // },
      contextmenu: [
        // {
        //     text: 'UU天堂',
        //     link: '/',
        // },
        // {
        //     text: '梦想远航',
        //     click: (player) => {
        //         console.log(player);
        //     },
        // },
      ],
      highlight: [
        {
          time: 20,
          text: '这是第 20 秒',
        },
        {
          time: 120,
          text: '这是 2 分钟',
        },
      ],
    });
    dp.on('ended', function () {
      console.log('视频加载完成');
    });
    dp.on('fullscreen', function () {
      if (isNative()) {
        console.log('原生环境切换横屏');
        // 原生环境切换横屏
        ScreenOrientation.lock({
          orientation: 'landscape',
        });
      }
      //   else {
      //     console.log('浏览器环境全屏');
      //     // 浏览器环境全屏
      //     // web 为全屏（根据屏幕方向），browser 是默认
      //     dp.fullScreen.request('web');
      //   }
    });
    dp.on('fullscreen_cancel', function () {
      if (isNative()) {
        ScreenOrientation.lock({
          orientation: 'portrait',
        });
      }
      //   else {
      //     dp.fullScreen.request('browser');
      //   }
    });
  }, []);

  return (
    <>
      <div id="dplayer"></div>
    </>
  );
};

export default Player;
